import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { OrderPlacesComponent } from './order-places.component';
import { OrderPickingComponent } from './order-picking.component';
@NgModule({
  declarations: [OrderPlacesComponent, OrderPickingComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  ],
  exports: [OrderPlacesComponent, OrderPickingComponent]
})
export class OrderStagingModule {}
